import React from 'react';
import { SITE } from '../../config/site';

// Catches rendering errors so one broken component never blanks the whole site.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Logged locally only — no third-party error tracker receives user data.
    // eslint-disable-next-line no-console
    console.error('Unhandled UI error', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    const subject = encodeURIComponent('Something broke on the website');
    const body = encodeURIComponent(`Page: ${window.location.pathname}\nError: ${String(this.state.error?.message || this.state.error)}\n\nWhat I was doing:\n`);
    return (
      <div className="flex min-h-[70vh] items-center justify-center px-6 py-32">
        <div className="max-w-md text-center">
          <p className="eyebrow">Unexpected error</p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight">This page hit a problem</h1>
          <p className="mt-4 text-ink-muted">Your data is safe. Reload the page to try again. If it keeps happening, tell us and we’ll fix it.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <button type="button" onClick={() => window.location.reload()} className="h-11 rounded-pill bg-primary px-5 text-sm font-medium text-on-primary">Reload page</button>
            <a href={`mailto:${SITE.supportEmail}?subject=${subject}&body=${body}`} className="inline-flex h-11 items-center rounded-pill px-5 text-sm font-medium ring-1 ring-line-strong">Report the problem</a>
          </div>
        </div>
      </div>
    );
  }
}
